module.exports = __webpack_public_path__ + "static/website-5dec3ad952c040a73cd8abceb666e416.png";